// A18 — THE STAGE SORTER. Brief 65 (brief 50 §4), the fourteenth of the sixteen.
//
// A matter's procedural stages in start-date order, with the undated ones last.
//
//   src/views/CaseView.tsx:1049-1056@8fdbbd6c x src/views/CollectiveCaseView.tsx:6638-6645@8fdbbd6c  100.0%
//
// IDENTICAL — the two eight-line blocks differ only in indentation. Nothing to
// parameterise.
//
// It copies before sorting, as both copies did: `Array.prototype.sort` mutates,
// and `cs.stages` is the row the rest of the view reads.
export const sortStagesByStart = (stages: any) =>
  (stages || []).slice().sort((a: any, b: any) => {
    const ad = a.startDate || "",
      bd = b.startDate || "";
    if (!ad && !bd) return 0;
    if (!ad) return 1;
    if (!bd) return -1;
    return ad.localeCompare(bd);
  });
